import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { unregister } from './registerServiceWorker';
import { Provider } from "react-redux";
import configureStore from "./redux/Store";
import App from './App';
import { createBrowserHistory } from 'history';
import { initializeIcons } from 'office-ui-fabric-react';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./accounts/types/msalAuthConfig"
import { getAADLoginConfigurationThunk, getB2CLoginConfigurationThunk, getClient, getPortalType } from './redux/thunks/AccountThunks';
import { setClient, setPortalType } from './redux/reducers/AccountReducer';
import { MATCHING_ENGINE, MEMBERS_PORTAL } from './accounts/Consts';
import { ConfigProvider } from 'antd';
import { applyCustomerStyles } from './util/appStyleUtils';
import { AppInsightsService } from './telemetry/services/AppInsightsService';
import { ErrorBoundary } from './telemetry/components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import frCA from 'antd/es/locale/fr_CA';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const history = createBrowserHistory();
const store = configureStore(history);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            cacheTime: 10 * 60 * 1000 // 10 minutes
        }
    }
});

unregister();

initializeIcons();

(async function () {
    try {
        const portalType = await getPortalType();
        const aadConfig = await getAADLoginConfigurationThunk();
        const b2cConfig = await getB2CLoginConfigurationThunk();
        const client = await getClient();

        // import generic styles first
        await import('./styles/environments/spanishpoint/style.scss');

        // import custom styles based on portal type and client, will override generic styles
        if (portalType === MEMBERS_PORTAL) {
            await applyCustomerStyles(client);
        } 

        // active application insights
        await AppInsightsService.initialize(history);

        if (portalType === MEMBERS_PORTAL) {
            msalConfig.auth.clientId = b2cConfig.clientId;
            msalConfig.auth.authority = b2cConfig.authority + b2cConfig.webPolicy;
            msalConfig.auth.knownAuthorities = [b2cConfig.authorityDomain];
            msalConfig.auth.redirectUri = "https://" + window.location.host + "/aadB2CLogin"
            msalConfig.auth.scope = b2cConfig.apiScope;
        }
        else if (portalType === MATCHING_ENGINE) {

            msalConfig.auth.clientId = aadConfig.clientId;
            msalConfig.auth.authority = aadConfig.authority;
            msalConfig.auth.scope = aadConfig.scope;
            msalConfig.auth.redirectUri = "https://" + window.location.host + "/aadLogin"
        }
        const msalInstance = new PublicClientApplication(msalConfig);

        store.dispatch(setPortalType(portalType));
        store.dispatch(setClient(client));
        var language = JSON.parse(localStorage.getItem('userLanguagePreferences'));


        ReactDOM.render(
            <MsalProvider instance={msalInstance}>
                <QueryClientProvider client={queryClient}>
                    <Provider store={store}>
                        <BrowserRouter basename={baseUrl}>
                            <ConfigProvider theme={{ hashed: false }} locale={language === "fr" ? frCA : undefined}>
                                <ErrorBoundary pageName="App">
                                    <App portalType={portalType} client={client} sessionTimeoutInMinutes={b2cConfig.sessionTimeoutInMinutes} dispatch={store.dispatch} instance={msalInstance} />
                                </ErrorBoundary>
                            </ConfigProvider>
                        </BrowserRouter>
                    </Provider>
                </QueryClientProvider>
            </MsalProvider>,
            rootElement);
    }
    catch (e) {
        console.log(e);
    }
})();